import React from "react";
import {Form} from "semantic-ui-react";

import CustomModal from "../CustomModal";
import Snackbar from "../Snackbar";

class EditMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payload: {
        name: '',
        tags: [],
      },
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      },
      tagsOptions: [],
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if(this.props.name !== nextProps.name) {
      this.setState({ payload: { name: nextProps.name || '', tags: nextProps.tags}, tagsOptions: nextProps.tagsOptions.map(x => ({text: x, value: x}))});
    }
  }

  handleState = (e) => {
    const {name, value} = e.target;
    const {payload} = this.state;
    this.setState({
      payload: {
        ...payload,
        [name]: value
      }
    });
  };

  resetSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      }
    })
  }

  addNewTag = (event, data) => {
    let {tagsOptions} = this.state;
    this.setState({tagsOptions: [...tagsOptions, {key: tagsOptions.length + 1, text: data.value, value: data.value}]})
  }

  onSubmit = () => {
    const {folderID, fileID, updateFolder, updateFile, onClose, tags: initTags} = this.props;
    const {payload: { name, tags }} = this.state;
    const deletedTags = initTags.filter(t => !tags.includes(t));
    const addedTags = tags.filter(t => !initTags.includes(t));
    if (folderID) {
      updateFolder({id: folderID, name, tags: tags.join(), addedTags, deletedTags})
        .then(result => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: 'Folder Edited!',
              success: true,
              error: false
            }
          });
        })
        .catch(error => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: error.data && error.data.message,
              success: false,
              error: true
            }
          });
        }).finally(onClose);
    } else if (fileID) {
      updateFile({id: fileID, name, tags: tags.join(), addedTags, deletedTags})
        .then(result => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: 'File Edited!',
              success: true,
              error: false
            }
          });
        })
        .catch(error => {
          this.setState({
            activeIndex: [0],
            selectedFolder: null,
            snackbar: {
              open: true,
              message: error.data && error.data.message,
              success: false,
              error: true
            }
          });
        }).finally(onClose);
    }
  }

  render() {
    const {payload: {name, tags}, snackbar, tagsOptions} = this.state;
    const {open, onClose, fileLoading, folderLoading} = this.props;
    return <>
      <CustomModal
        open={open}
        onClose={onClose}
        footer={true}
        title='Edit Media'
        onSubmit={this.onSubmit}
        submitLoader={fileLoading || folderLoading}
      >
        <Form>
          <Form.Field>
            <label>Name</label>
            <Form.Input
              fluid
              id="name"
              value={name}
              onChange={this.handleState}
              name="name"
              placeholder="Name"
            />
          </Form.Field>
          <Form.Field>
            <label>Tag(s)</label>
            <Form.Dropdown
              placeholder='Tag(s)'
              name='tags'
              fluid
              multiple
              search
              selection
              closeOnChange
              allowAdditions
              value={tags}
              options={tagsOptions}
              onAddItem={this.addNewTag}
              onChange={(e, { value }) => this.setState(state => ({ ...state, payload: { ...state.payload, tags: value }}))}
            />
          </Form.Field>
        </Form>
      </CustomModal>
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        error={snackbar.error}
        success={snackbar.success}
        onClose={this.resetSnackbar}
      />
    </>
  }
}

export default EditMedia;
